module.exports = __webpack_public_path__ + "img/2.776d26e2.jpg";